export const setLanguage = lang => {
  return {
    type: 'SET_LANGUAGE',
    value: lang
  }
}